module.exports = __webpack_public_path__ + "media/images/home/mini/screen_2-e1b8316985a9a7cbbd0f91df3af00abb.png";